interface IconProps {
  readonly className?: string;
  /** Nombre accesible. Va como <title> para que el crédito se lea completo. */
  readonly title: string;
}

/**
 * Íconos del crédito de autoría del footer.
 *
 * Van como SVG inline y no como emoji (❤️ ☕) a propósito: el emoji depende de
 * la fuente de color del sistema, así que cambia de forma entre Windows, macOS
 * y Android, y en el export a PDF de la landing se embebe como bitmap ajeno a
 * la paleta. En SVG heredan el tamaño y el color del texto y se imprimen como
 * vectores.
 */

/** Corazón relleno — el «con amor». */
export function HeartIcon({ className, title }: IconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      className={className}
      role="img"
      focusable="false"
    >
      <title>{title}</title>
      <path
        d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"
        fill="currentColor"
      />
    </svg>
  );
}

/** Taza de café con su vapor — el combustible. */
export function CoffeeIcon({ className, title }: IconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      className={className}
      role="img"
      focusable="false"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.9"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <title>{title}</title>
      <path d="M18 8h1a4 4 0 0 1 0 8h-1" />
      <path d="M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z" />
      <path d="M6 1v3" />
      <path d="M10 1v3" />
      <path d="M14 1v3" />
    </svg>
  );
}
